exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);

// module
exports.push([module.id, "html {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  box-sizing: border-box;\n  background: #fff; }\n\nbody {\n  margin: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/index.scss
// module id = 577
// module chunks = 0